<template>
  <div>
    <v-sheet
      color="primary"
      elevation="2"
      class="white--text font-weight-medium pa-2 mb-7"
      v-if="charge && edit"
    >
      {{ charge.help_text }}
    </v-sheet>

    <v-data-table
      :headers="headers"
      :items="model.activities"
      :items-per-page="20"
      class="elevation-1 mb-7"
      no-data-text="No hay registros agregados..."      
    >
      <template v-slot:top v-if="edit">
        <v-toolbar flat>
          <v-toolbar-title>Actividades</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Dialog add supervisor -->
          <v-dialog v-model="dialogAdd" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Agregar
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ titleDialog }} Actividad</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="form" v-model="formAdd">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-select
                          :items="typeActivity"
                          v-model="modelActivity.type_id"
                          item-text="name"
                          item-value="id"
                          label="Tipo"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="modelActivity.name"
                          label="Nombre o Tema"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="modelActivity.unit"
                          label="Unidad"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="modelActivity.objective"
                          label="Objetivo"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="modelActivity.description"
                          label="Descripción"
                          required
                        ></v-textarea>
                      </v-col>                    
                      <v-col cols="12">
                        <evidences-form
                          :model="modelActivity"
                          :charge="charge"
                          :rules="rules"
                          :edit="true"
                        ></evidences-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  {{ titleDialog }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog delete supervisor -->
          <v-dialog v-model="dialogDelete" max-width="520px">
            <v-card>
              <v-card-title class="headline"
                >Seguro que desea eliminar esta actividad?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteConfirm"
                  >Aceptar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.type`]="item">
        {{ edit ? item.item.type : item.item.type_activity.name }}
      </template>
      <template v-slot:[`item.documents`]="item">
        <span v-if="edit">
          {{ item.item.evidences ? item.item.evidences.length : 0 }}
          Evidencia(s)
        </span>
        <v-btn
          color="blue"
          class="white--text mr-2"
          small
          rounded
          v-else
          v-for="(value, index) in item.item.evidences"
          v-bind:key="index"
          target="_blank"
          :href="value.url"
        >
          Evidencia {{ index + 1 }}
        </v-btn>
      </template>
      <template v-slot:[`item.actions`]="item">
        <v-tooltip bottom v-if="edit">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="deleteActivity(item.item)"
            >
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <span v-else>N/A</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_ALERT } from "@/store/alert";
import EvidencesForm from "@/components/report/create/Evidences";
export default {
  name: "Activities",
  props: {
    model: {
      type: Object,
      required: true,
    },
    charge: {
      required: true,
    },
    typeActivity: {
      required: true,
    },
    rules: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    EvidencesForm,
  },
  data: () => ({
    current: null,
    formAdd: true,
    dialogAdd: false,
    editedIndex: -1,
    dialogDelete: false,
    modelActivity: {
      type: "",
      name: "",
      unit: "",
      objective: "",
      description: "",
      counselor_name: "",
      reviewed_staff_names: "",
      evidences: [],
    },
    headers: [
      { text: "Tipo Actividad", value: "type", sortable: false },
      { text: "Nombre", value: "name", sortable: false },
      { text: "Descripción", value: "description", sortable: false },
      { text: "Evidencias", value: "documents", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(["getTypeActivities"]),
    titleDialog() {
      return this.current ? "Editar" : "Agregar";
    },
  },
  methods: {
    deleteActivity(item) {
      this.editedIndex = this.model.activities.indexOf(item);
      this.dialogDelete = true;
    },
    deleteConfirm() {
      this.model.activities.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.modelActivity = {
          type_id: "",
          name: "",
          unit: "",
          objective: "",
          description: "",
          counselor_name: "",
          reviewed_staff_names: "",
          evidences: [],
        };
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.current = null;
        this.editedIndex = -1;
      });
    },
    save() {
      //Validate inputs
      if (
        this.modelActivity.name == "" ||
        this.modelActivity.type_id == "" ||
        this.modelActivity.description == "" ||
        !this.modelActivity.evidences.length
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      var typeActivity = this.typeActivity.find(obj => obj.id == this.modelActivity.type_id);
      this.modelActivity.type = typeActivity.name;
      this.model.activities.push(this.modelActivity);
      this.close();
    },
  },
};
</script>

<style>
</style>